import React from "react";
import { useDispatch } from "react-redux";
import { WithTheme } from "src/styles/createStyledComponentsTheme";
import styled, { withTheme } from "styled-components";
import Indicator from "src/components/icons/Indicator";
import { clearDealerChanges } from "src/store/actions/deal";

interface Props {
    featureId: string;
    hasChanged: boolean;
    children: any;
}

const HasChangedListItem = styled("li")`
    border-color: ${(props) => props.theme.palette.primary.main};
    outline: solid 1px ${(props) => props.theme.palette.primary.main};
    outline-style: auto;
`;

export const CellChangeIndicator = ({ featureId, hasChanged, theme, children }: Props & WithTheme) => {
    const dispatch = useDispatch();

    const toBold = featureId === "PurchasePrice" ? "TableCompare__features-bold" : "";

    if (hasChanged) {
        return (
            <HasChangedListItem
                className={`TableCompare__vehicle-feature ${toBold}`}
                onMouseEnter={() => dispatch(clearDealerChanges())}
            >
                <div
                    style={{
                        position: "relative",
                        width: "0",
                    }}
                >
                    <Indicator
                        style={{
                            position: "absolute",
                            top: "-0.8em",
                            left: "0.5em",
                            backgroundColor: "white",
                            zIndex: 651,
                        }}
                        fill={theme.palette.primary.main}
                        stroke={theme.palette.primary.dark}
                    />
                </div>
                {children}
            </HasChangedListItem>
        );
    }

    return <li className={`TableCompare__vehicle-feature ${toBold}`}>{children}</li>;
};

export default withTheme(CellChangeIndicator);
